import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const CreateTutorButton = ({ loading, hasProFeatures }) => {
  return (
    !hasProFeatures ? (
      <Tooltip>
        <TooltipTrigger asChild>
          <div className='cursor-not-allowed'>
            <Button disabled type="button">
              Create tutor
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>Upgrade to pro</TooltipContent>
      </Tooltip>
    ) : (
      <Button
        type='submit'
        disabled={loading}
        loading={loading}
      >
        Create tutor
      </Button>
    )
  )
}

export default CreateTutorButton
